var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9998 5.1998C4.55798 5.1998 4.1998 5.55798 4.1998 5.9998V19.9998C4.1998 20.4416 4.55798 20.7998 4.9998 20.7998H18.9998C19.4416 20.7998 19.7998 20.4416 19.7998 19.9998V5.9998C19.7998 5.55798 19.4416 5.1998 18.9998 5.1998H4.9998ZM2.5498 5.9998C2.5498 4.23249 3.23249 3.5498 4.9998 3.5498H18.9998C20.7671 3.5498 21.4498 4.23249 21.4498 5.9998V19.9998C21.4498 21.7671 20.7671 22.4498 18.9998 22.4498H4.9998C3.23249 22.4498 2.5498 21.7671 2.5498 19.9998V5.9998Z",
    fill: "#232F3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.125 1.5C16.7463 1.5 17.25 1.94072 17.25 2.48438V5.76563C17.25 6.30928 16.7463 6.75 16.125 6.75C15.5037 6.75 15 6.30928 15 5.76563V2.48438C15 1.94072 15.5037 1.5 16.125 1.5Z",
    fill: "#232F3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 1.5C8.49632 1.5 9 1.94072 9 2.48438V5.76563C9 6.30928 8.49632 6.75 7.875 6.75C7.25368 6.75 6.75 6.30928 6.75 5.76563V2.48438C6.75 1.94072 7.25368 1.5 7.875 1.5Z",
    fill: "#232F3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9.75C3 9.33579 3.47405 9 4.05882 9H19.9412C20.5259 9 21 9.33579 21 9.75C21 10.1642 20.5259 10.5 19.9412 10.5H4.05882C3.47405 10.5 3 10.1642 3 9.75Z",
    fill: "#232F3E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b26a4081a4c4df32e2b970ecdbbf515c.svg";
export { ForwardRef as ReactComponent };